import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Col, Container, Row, Table } from 'reactstrap';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import CheckIcon from '../../shared/components/custom/CheckIcon';
import Loading from '../../shared/components/custom/Loading';
import useModal from '../../shared/hooks/useModal';
import Api from '../../util/api';
import { formatCurrencyNumber } from '../../util/functions';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import { formatDate } from '../../util/date-and-time';
import FormCard from '../../shared/components/custom/FormCard';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';

const PaymentOptionsListPage = ({ entityId, type }) => {
  const config = useConfig();
  const history = useHistory();
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [loadingPaymentOptions, setLoadingPaymentOptions] = useState(true);
  const [handleModal, visible, deleteID] = useModal();

  const p = partial('paymentOptions');
  const s = partial('shared');

  const fetchPaymentOptions = async () => {
    setLoadingPaymentOptions(true);
    try {
      const resPaymentOptions =
        await Api.transactions.getPaymentOptions(entityId);
      setPaymentOptions(resPaymentOptions);
      setLoadingPaymentOptions(false);
    } catch (err) {
      toast.error(err || `${p('auctionRetrievingERROR')}`);
      setLoadingPaymentOptions(false);
    }
  };
  useEffect(() => {
    fetchPaymentOptions();
  }, []);
  const deletePaymentOption = async () => {
    setLoadingPaymentOptions(true);
    try {
      await Api.transactions.deletePaymentOption(deleteID);
      toast.success(`${p('paymentOptionDeleted')}`);
    } catch (err) {
      toast.error(err || `${p('paymentOptionDeletedERROR')}`);
    } finally {
      handleModal();
      fetchPaymentOptions();
    }
  };

  const renderPaymentOptions = () => {
    return paymentOptions.map((paymentOption, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`payment-option-${paymentOption.id}`}
      >
        <td>
          <CheckIcon state={!!paymentOption.isActive} />
        </td>
        <td>
          <div className="flex-Vcenter">
            <Link
              to={`/payment-options/edit/${paymentOption.entityType}/${paymentOption.id}`}
            >
              {p(`providerType-${paymentOption.providerType}`)}
            </Link>
          </div>
        </td>
        <td>
          <b>
            {formatCurrencyNumber(Number(paymentOption.price) / 100)}{' '}
            {config.currencyCaps}
          </b>
        </td>
        <td>{p(`paymentType-${paymentOption.paymentType}`)}</td>
        <td>
          {paymentOption.optionType === 'till_date'
            ? `untill ${formatDate(paymentOption.optionValue)}`
            : `${paymentOption.optionValue} ${paymentOption.optionType === 'days' ? 'days' : 'months'}`}
        </td>
        {type === 'tier' && (
          <td>
            {paymentOption.salesEndDate
              ? formatDate(paymentOption.salesEndDate)
              : '-'}
          </td>
        )}
        {type === 'tier' && <td>{paymentOption.badgeText || '-'}</td>}
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                history.push(
                  `/payment-options/edit/${paymentOption.entityType}/${paymentOption.id}`
                )
              }
              title={s('edit')}
              id={`edit-payment-option-${paymentOption.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => handleModal(paymentOption.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-payment-option-${paymentOption.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <Container>
      <Loading loading={loadingPaymentOptions} />
      <DeleteModal
        visible={visible}
        type={p('thePaymentOption')}
        handleModal={handleModal}
        modalAction={deletePaymentOption}
      />
      <Row>
        <Col>
          <FormCard
            title={p('paymentOptions')}
            actions={
              <Link to={`/payment-options/create/${type}/${entityId}`}>
                <Button size="sm" color="primary" className="mb-0">
                  {s('create')}
                </Button>
              </Link>
            }
            bodyClassName="form-card__body--flush"
            className="mb-3"
          >
            <Table responsive striped className="table--roomy">
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('active')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">
                      {p('providerType')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{p('price')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">
                      {p('paymentType')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{p('dueDate')}</div>
                  </th>
                  {type === 'tier' && (
                    <th style={{ color: '#4D576A' }}>
                      <div className="flex alignItems-center">
                        {p('salesEndDate')}
                      </div>
                    </th>
                  )}
                  {type === 'tier' && (
                    <th style={{ color: '#4D576A' }}>
                      <div className="flex alignItems-center">
                        {p('badgeText')}
                      </div>
                    </th>
                  )}
                  <th />
                </tr>
              </thead>
              <tbody>{renderPaymentOptions()}</tbody>
            </Table>
          </FormCard>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentOptionsListPage;
